import { render, staticRenderFns } from "./DesignRirekisho001Edit.vue?vue&type=template&id=c62dd6b4&scoped=true"
import script from "./DesignRirekisho001Edit.vue?vue&type=script&setup=true&lang=ts"
export * from "./DesignRirekisho001Edit.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DesignRirekisho001Edit.vue?vue&type=style&index=0&id=c62dd6b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62dd6b4",
  null
  
)

export default component.exports